import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import React from 'react'
import DropMeGLN from "./DropMeGLN"; 
import GLOBALS from "../../utils/Globals";
import Footer from "../Footer/Footer";

function ImportGLN() {
  
  return (
    <>
      <br></br>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold text-gray-900">
              Import Single GLN Data
            </h1>
            <p className="mt-2 text-sm text-gray-700">
              To import GLN data, drag and drop a file
            </p>

            <br></br>
            <DropMeGLN />
          </div>
        </div>
      </div>
      <br></br>
      <Footer />
    </>
  );
}

export default ImportGLN